<template>
	<div class="mi-cuenta">
		<div class="mi-cuenta-left">
			<h1>Datos personales</h1>
			<div class="input-row">
				<div class="input-group input-group-50">
					<label for="nombre">Nombre</label>
					<!-- <input type="text" id="nombre" name="nombre" v-model="nombre"> -->
					<div class="input-disabled">{{ nombre }}</div>
				</div>
				<div class="input-group input-group-50">
					<label for="apellido">Apellido</label>
					<!-- <input type="text" id="apellido" name="apellido" v-model="apellido"> -->
					<div class="input-disabled">{{ apellido }}</div>
				</div>
			</div>
			<div class="input-row">
				<div class="input-group">
					<label>Correo electrónico</label>
					<div class="input-disabled">{{ usuarioEmail }}</div>
				</div>
			</div>
			<div class="input-row">
				<div class="input-group input-group-50" v-if="tipoDocumento">
					<label for="tipoDocumento">Tipo de documento</label>
					<!-- <multiselect name="tipoDocumento" id="tipoDocumento" v-model="tipoDocumento" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
						<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
						<span slot="noResult">No se encontró tipo.</span>
						<span slot="noOptions">No hay tipos de docuemntos disponibles.</span>
					</multiselect> -->
					<div class="input-disabled">{{ tipoDocumento.descripcion }}</div>
				</div>
				<div class="input-group input-group-50">
					<label for="documento">Documento</label>
					<!-- <input type="text" id="documento" name="documento" v-model="documento"> -->
					<div class="input-disabled">{{ documento }}</div>
				</div>
			</div>
			<div class="input-row">
				<div class="input-group input-group-50">
					<label for="fchNacimiento">Fecha de nacimiento</label>
					<!-- <date-picker name="fchNacimiento" id="fchNacimiento" :lang="lang" :format="'DD/MM/YYYY'" v-model="fchNacimiento" placeholder="DD/MM/YYYY"></date-picker> -->
					<div class="input-disabled">{{ fchNacimientoTxt }}</div>
				</div>
				<div class="input-group input-group-50">
					<label for="telefono">Teléfono</label>
					<!-- <input type="text" id="telefono" name="telefono" v-model="telefono"> -->
					<div class="input-disabled">{{ telefono }}</div>
				</div>
			</div>
			<!-- <div class="input-row" v-if="pais !== null">
				<div class="input-row-aux" v-if="parseInt(pais.valor) === 1">
					<div class="input-group input-group-50">
						<label for="pais">Departamento</label>
						<multiselect v-model="departamento" :options="departamentos" track-by="descripcion" label="descripcion" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true" @input="cambioDepartamento($event)">
							<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
							<span slot="noResult">No se encontró departamento.</span>
							<span slot="noOptions">No hay departamentos disponibles.</span>
						</multiselect>
					</div>
					<div class="input-group input-group-50">
						<label for="pais">Ciudad</label>
						<multiselect v-model="ciudad" :options="ciudades" track-by="descripcion" label="descripcion" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
							<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
							<span slot="noResult">No se encontró ciudad.</span>
							<span slot="noOptions">No hay ciudades disponibles.</span>
						</multiselect>
					</div>
				</div>
			</div> -->
			<div class="input-row">
				<div class="input-group input-group-50" v-if="pais">
					<label for="pais">País</label>
					<!-- <multiselect v-model="pais" :options="paises" track-by="descripcion" label="descripcion" :searchable="true" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true" @input="cambioPais($event)">
						<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
						<span slot="noResult">No se encontró país.</span>
						<span slot="noOptions">No hay países disponibles.</span>
					</multiselect> -->
					<div class="input-disabled">{{ pais.descripcion }}</div>
				</div>
				<!-- <div class="input-group input-group-50">
					<label for="genero">Género</label>
					<multiselect name="genero" id="genero" v-model="genero" :options="generos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
						<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
						<span slot="noResult">No se encontró género.</span>
						<span slot="noOptions">No hay géneros disponibles.</span>
					</multiselect>
				</div> -->
			</div>
			<div class="input-row">
				<span class="actualizar-info-text">Puedes actualizar tus datos en Nacional.uy</span>
			</div>
			<!-- <div class="input-row">
				<div class="input-group checkbox-acepto-comunicaciones">
					<input type="checkbox" name="acepto-comunicaciones" id="acepto-comunicaciones">
					<label for="acepto-comunicaciones">
						<div class="checkbox-custom"></div>
						<span>Acepto recibir comunicaciones comerciales e informativas del Club Nacional de Football</span>
					</label>
				</div>
			</div> -->
			<div class="input-row">
				<!-- <button class="btn" @click="actualizarUsuario">Guardar datos</button> -->
				<a class="btn" :href="urlPerfilNacional">Actualizar datos <external-link-icon></external-link-icon></a>
			</div>
			<!-- <div class="input-row">
				<div class="borrar-cuenta">Borrar mi cuenta</div>
			</div> -->
			<!-- <div class="input-row input-row-start">
				<div class="perfil-errors" v-if="$store.state.erroresUsuario.length">
					<ul>
						<li>{{ this.$store.state.erroresUsuario[0].msg }}</li>
					</ul>
				</div>
				<VueLoadingButton type="submit" aria-label="" :loading="isLoadingBoton">Actualizar perfil</VueLoadingButton>
			</div> -->
		</div>
		<div class="mi-cuenta-right">
			<!-- <div class="mi-carne-socio">
				<span class="mi-cuenta-right-title">Carné de socio</span>
				<div class="cuenta-right-row">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Socio Nº</span>
						<span class="mi-cuenta-right-valor">{{ socioNro }}</span>
					</div>
				</div>
				<div class="cuenta-right-row">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Desde</span>
						<span class="mi-cuenta-right-valor">8 Abril 2010</span>
					</div>
				</div>
				<div class="cuenta-right-row row-last">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Categoría</span>
						<span class="mi-cuenta-right-valor">{{ socioCategoria }}</span>
					</div>
				</div>
			</div>
			<div class="mi-butaca">
				<span class="mi-cuenta-right-title">Mi butaca</span>
				<div class="cuenta-right-row">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Código</span>
						<span class="mi-cuenta-right-valor">{{ butacaNro }}</span>
					</div>
				</div>
				<div class="cuenta-right-row">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Tribuna</span>
						<span class="mi-cuenta-right-valor">José María Delgado</span>
					</div>
				</div>
				<div class="cuenta-right-row row-last">
					<div class="cuenta-right-group cuenta-right-group-33">
						<span class="mi-cuenta-right-label">Sector</span>
						<span class="mi-cuenta-right-valor">8</span>
					</div>
					<div class="cuenta-right-group cuenta-right-group-33">
						<span class="mi-cuenta-right-label">Fila</span>
						<span class="mi-cuenta-right-valor">15</span>
					</div>
					<div class="cuenta-right-group cuenta-right-group-33">
						<span class="mi-cuenta-right-label">Asiento</span>
						<span class="mi-cuenta-right-valor">4</span>
					</div>
				</div>
			</div> -->
			<div class="mi-carne-socio">
				<span class="mi-cuenta-right-title">Exclusivo para socios</span>
				<div>
					<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="400" height="258" viewBox="0 0 400 258" class="card card--back">
						<defs>
							<rect id="cartao-socio-tras-a" width="400" height="258" x="0" y="0" rx="12"></rect>
						</defs>
						<g fill="none" fill-rule="evenodd">
							<use fill="#FFF" xlink:href="#cartao-socio-tras-a"></use>
							<rect width="88" height="88" x="32" y="32" fill="#E8E8E8" rx="44"></rect>
							<rect width="232" height="24" x="136" y="32" fill="#E8E8E8" rx="6"></rect>
							<rect width="232" height="24" x="136" y="64" fill="#E8E8E8" rx="6"></rect>
							<rect width="232" height="24" x="136" y="96" fill="#E8E8E8" rx="6"></rect>
							<rect width="336" height="24" x="32" y="170" fill="#E8E8E8" rx="6"></rect>
							<rect width="336" height="24" x="32" y="202" fill="#E8E8E8" rx="6"></rect>
						</g>
					</svg>
					<img width="100%" src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/carton-socio.png" alt="Hacete socio" class="card card--front">
				</div>
				<div class="cuenta-right-row row-last" v-if="socioNro">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Socio Nº</span>
						<span class="mi-cuenta-right-valor">{{ socioNro }}</span>
					</div>
				</div>
			</div>
			<div class="hacete-socio" v-if="!socioNro">
				<a href="https://www.socionacional.uy/socionacional/servlet/cnf.sw_home" target="_blank">Hacete socio</a>
			</div>
			<!-- <div class="mi-butaca">
				<span class="mi-cuenta-right-title">Mi butaca</span>
				<div class="cuenta-right-row row-last">
					<div class="cuenta-right-group">
						<span class="mi-cuenta-right-label">Código</span>
						<span class="mi-cuenta-right-valor">{{ butacaNro }}</span>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	// import VueLoadingButton from 'vue-loading-button'
	// import DatePicker from 'vue2-datepicker'

	export default{
		name: 'perfil',
		data(){
			return {
				urlPerfilNacional: process.env.VUE_APP_URL_NACIONALUY_USER,
				actualizadoOk: false,
				isLoadingBoton: false,
				usuarioId: localStorage.getItem('usuario_id'),
				usuarioEmail: '',
				personaId: 0,
				nombre: '',
				apellido: '',
				fchNacimiento: null,
				pais: null,
				paises: [],
				departamento: null,
				departamentos: [],
				ciudad: null,
				ciudades: [],
				genero: null,
				generos: [
					{ valor: 'H', descripcion: 'Hombre'},
					{ valor: 'M', descripcion: 'Mujer'},
					{ valor: 'O', descripcion: 'Otro'}
				],
				telefono: '',
				tipoDocumento: null,
				tipoDocumentos: [],
				documento: '',
				socioNro: '',
				butacaNro: '',
				socioCategoria: 'Primer estadio mundialista',
				fotoSeleccionada: '',
				lang: {
					formatLocale: {
						months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre'],
						monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Dic'],
						weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
						weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
						weekdaysMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa']
					}
				}
			}
		},
		computed: {
			fchNacimientoTxt: function(){
				if(this.fchNacimiento){
					let year = this.fchNacimiento.getFullYear();
					let month = (1 + this.fchNacimiento.getMonth()).toString().padStart(2, '0');
					let day = this.fchNacimiento.getDate().toString().padStart(2, '0');

					return day + '/' + month + '/' + year;
				} else {
					return '';
				}
			}
		},
		methods: {
			actualizarUsuario(){
				this.actualizadoOk = false;
				this.isLoadingBoton = true;
				this.$store.commit('limpiarErroresUsuario');

				if(!this.nombre){
					this.$store.commit('insertarErrorUsuario', 'Ingresa tus nombres');
					this.isLoadingBoton = false;
				} else {
					if(!this.apellido){
						this.$store.commit('insertarErrorUsuario', 'Ingresa tus apellidos');
						this.isLoadingBoton = false;
					} else {
						if(!this.documento){
							this.$store.commit('insertarErrorUsuario', 'Ingresa un documento');
							this.isLoadingBoton = false;
						} else {
							if(!this.telefono){
								this.$store.commit('insertarErrorUsuario', 'Ingresa un telefono');
								this.isLoadingBoton = false;
							} else {
								if(this.telefono.length < 8){
									this.$store.commit('insertarErrorUsuario', 'Teléfono inválido');
									this.isLoadingBoton = false;
								} else {
									var genero;
									if(this.genero === null){
										genero = ''
									} else {
										genero = this.genero.valor
									}

									var pais, departamento, ciudad;
									if(this.pais === null){
										pais = null
									} else {
										pais = parseInt(this.pais.valor);
									}
									if(this.departamento === null){
										departamento = null
									} else {
										departamento = parseInt(this.departamento.valor);
									}
									if(this.ciudad === null){
										ciudad = null
									} else {
										ciudad = parseInt(this.ciudad.valor);
									}

									// Validación Ok -> Registro usuario
									this.$store.dispatch('actualizarUsuario', {
										usuarioId: this.usuarioId,
										personaId: parseInt(this.personaId),
										nombre: this.nombre,
										apellido: this.apellido,
										documentoTipo: parseInt(this.tipoDocumento.valor),
										documento: this.documento,
										telefono: this.telefono,
										socioNro: this.socioNro,
										butacaNro: this.butacaNro,
										fchNacimiento: this.fchNacimiento,
										pais: pais,
										departamento: departamento,
										ciudad: ciudad,
										genero: genero
									})
									.then(response => {
										this.$store.dispatch('actualizarNombre', {
											nombre: this.nombre
										})
										this.isLoadingBoton = false;
										this.actualizadoOk = true;

										this.$toast.success('Perfil actualizado correctamente', {
											position: "bottom-left",
											timeout: 7000,
											closeOnClick: true,
											pauseOnFocusLoss: false,
											pauseOnHover: true,
											draggable: false,
											draggablePercent: 0.6,
											showCloseButtonOnHover: true,
											hideProgressBar: true,
											closeButton: "button",
											icon: true,
											rtl: false
										});
									})
									.catch(error => {
										this.isLoadingBoton = false;
									})
								}
							}
						}
					}
				}
			},
			async cambioPais(){
				return new Promise((resolve, reject) => {
					this.departamentos = [];
					this.ciudades = [];
					this.departamento = null;
					this.ciudad = null;

					if(this.pais !== null){
						axios.post('/WSGeoDiv1', {
							PaisId: parseInt(this.pais.valor)
						})
						.then(response => {
							for(var n=0; n<response.data.SDTGeoDiv1.length; n++){
								this.departamentos.push({ valor: parseInt(response.data.SDTGeoDiv1[n].GeoDiv1Id), descripcion: response.data.SDTGeoDiv1[n].GeoDiv1Nombre });
							}
							resolve();
						})
					}
				})
			},
			async cambioDepartamento(){
				return new Promise((resolve, reject) => {
					this.ciudades = [];
					this.ciudad = null;

					if(this.pais !== null && this.departamento !== null){
						axios.post('/WSGeoDiv2', {
							PaisId: parseInt(this.pais.valor),
							GeoDiv1Id: parseInt(this.departamento.valor)
						})
						.then(response => {
							for(var l=0; l<response.data.SDTGeoDiv2.length; l++){
								this.ciudades.push({ valor: parseInt(response.data.SDTGeoDiv2[l].GeoDiv2Id), descripcion: response.data.SDTGeoDiv2[l].GeoDiv2Nombre });
							}
							resolve();
						})
					}
				})
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipo', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumento = { valor: parseInt(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async cargoPaises(){
				// Obtengo países
				try{
					let response = await axios.post('/WSPais', {});

					for(var m=0; m<response.data.SDTPais.length; m++){
						this.paises.push({ valor: parseInt(response.data.SDTPais[m].PaisId), descripcion: response.data.SDTPais[m].PaisNombre });
					}
				} catch(error){
					this.$router.push({ name: 'error' });
				}
			},
			async datosUsuario(){
				// Obtengo datos de usuario
				try {
					let response = await axios.post('/WSUsuario', { UsuarioId: this.usuarioId }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

					if(response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					}

					this.usuarioEmail = response.data.SDTUsuario.UsuarioEmail;
					this.nombre = response.data.SDTUsuario.UsuarioPersonaNombre;
					this.apellido = response.data.SDTUsuario.UsuarioPersonaApellido;

					if(response.data.SDTUsuario.UsuarioPersonaFchNacimiento !== '0000-00-00' && response.data.SDTUsuario.UsuarioPersonaFchNacimiento !== null){
						// Tiene fecha de nacimiento
						var fchNacimientoSplit = response.data.SDTUsuario.UsuarioPersonaFchNacimiento.split('-');
						this.fchNacimiento = new Date(parseInt(fchNacimientoSplit[0]), parseInt(fchNacimientoSplit[1]) - 1, parseInt(fchNacimientoSplit[2]), 0, 0, 0, 0)
					} else {
						this.fchNacimiento = null;
					}

					this.personaId = response.data.SDTUsuario.UsuarioPersonaId;

					if(parseInt(response.data.SDTUsuario.PaisId) > 0){
						this.pais = this.paises.filter(function(p){
							return parseInt(response.data.SDTUsuario.PaisId) === parseInt(p.valor)
						})[0];

						await this.cambioPais();

						if(parseInt(response.data.SDTUsuario.GeoDiv1Id) > 0){
							this.departamento = this.departamentos.filter(function(dep){
								return parseInt(response.data.SDTUsuario.GeoDiv1Id) === parseInt(dep.valor)
							})[0];

							await this.cambioDepartamento();

							this.ciudad = this.ciudades.filter(function(ciu){
								return parseInt(response.data.SDTUsuario.GeoDiv2Id) === parseInt(ciu.valor)
							})[0];
						}
					}

					this.telefono = response.data.SDTUsuario.UsuarioPersonaTelefono;

					this.tipoDocumento = this.tipoDocumentos.filter(function(tip){
						return parseInt(response.data.SDTUsuario.UsuarioPersonaDocumentoTipoId) === parseInt(tip.valor)
					})[0];

					this.documento = response.data.SDTUsuario.UsuarioPersonaDocumento;
					this.socioNro = response.data.SDTUsuario.UsuarioPersonaSocioNro;
					this.butacaNro = response.data.SDTUsuario.UsuarioPersonaButacaNro;

					if(response.data.SDTUsuario.UsuarioPersonaGenero === ''){
						this.genero = null;
					} else {
						this.genero = this.generos.filter(function(gen){
							return response.data.SDTUsuario.UsuarioPersonaGenero === gen.valor
						})[0];
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			}
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.cargoPaises();
			await this.datosUsuario();
			this.$store.dispatch('cargando', false);
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}
</style>

<style lang="scss">
	@import '~vue2-datepicker/scss/index.scss';

	.mx-datepicker{
		width: 100% !important;

		.mx-input-wrapper{
			.mx-input{
				font-size: 16px !important;
				line-height: 25px !important;
				border: none !important;
				border-bottom: 1px solid var(--color-grey-light) !important;
				display: block !important;
				width: 100% !important;
				font-weight: var(--font-weight-bold) !important;
				-webkit-letter-spacing: 0 !important;
				-moz-letter-spacing: 0 !important;
				-ms-letter-spacing: 0 !important;
				letter-spacing: 0 !important;
				color: var(--color-dark) !important;
				font-family: var(--font-family-poppins) !important;
				text-transform: uppercase !important;
				padding-top: 8px !important;
				padding-bottom: 10px !important;
				padding-left: 0px !important;
				padding-right: 0px !important;
				outline: none !important;
				background-color: var(--color-white) !important;
				border-radius: 0px !important;
				-webkit-box-shadow: none !important;
    			box-shadow: none !important;
				min-height: 44px !important;

				&::-webkit-input-placeholder {
					font-size: 16px !important;
					line-height: 25px !important;
					color: var(--color-grey) !important;
					font-weight: var(--font-weight-bold) !important;
					font-family: var(--font-family-poppins) !important;
					text-transform: uppercase !important;
				}
				&::-moz-placeholder {
					font-size: 16px !important;
					line-height: 25px !important;
					color: var(--color-grey) !important;
					font-weight: var(--font-weight-bold) !important;
					font-family: var(--font-family-poppins) !important;
					text-transform: uppercase !important;
				}
				&::-ms-input-placeholder {
					font-size: 16px !important;
					line-height: 25px !important;
					color: var(--color-grey) !important;
					font-weight: var(--font-weight-bold) !important;
					font-family: var(--font-family-poppins) !important;
					text-transform: uppercase !important;
				}
			}
		}
	}

	.mx-icon-calendar, .mx-icon-clear{
		color: var(--color-grey) !important;
	}

	.mx-datepicker-main, .mx-btn{
		font-family: var(--font-family-fira) !important;
	}

	.mx-datepicker-main{
		font-family: var(--font-family-fira) !important;
		border: 1px solid #ddd !important;
		border-radius: 5px !important;
		box-shadow: 0 0 10px 0 rgba(183, 192, 206, 0.2) !important;
	}

	.mx-btn:hover{
		border-color: var(--color-blue-dark) !important;
		color: var(--color-blue-dark) !important;
	}

	.mx-calendar-content .cell.active{
		background-color: var(--color-blue-dark) !important;
	}

	.mx-table-date .today{
		color: var(--color-white) !important;
	}

	.mx-input:hover, .mx-input:focus{
		border-color: var(--color-blue-dark) !important;
	}

	.mx-datepicker-header{
		background-color: var(--color-blue-dark) !important;

		.mx-btn{
			color: var(--color-white) !important;
		}
	}
</style>

<style lang="scss" scoped>
	.mi-cuenta{
		width: 100%;
		@include flex(row, space-between, flex-start);

		.mi-cuenta-left{
			width: calc(66.66% - 16px);
			background-color: var(--color-white);
			padding: 48px 50px 40px 50px;

			h1{
				margin: 0;
				color: var(--color-red);
				font-weight: initial;
				font-size: 48px;
				line-height: 46px;
				font-family: var(--font-family-kapra-bold);
				text-transform: uppercase;
				margin-bottom: 32px;
			}

			.input-row{
				width: 100%;
				margin: 0;
				padding: 0;
				@include flex(row, space-between, center);
				position: relative;

				.input-row-aux{
					width: 100%;
					margin: 0;
					padding: 0;
					@include flex(row, space-between, center);
					position: relative;
				}

				.input-group{
					width: 100%;
					padding: 0px 16px 16px 16px;
					margin: 0;
					@include flex(column, center, flex-start);
					position: relative;

					&:first-child{
						padding-left: 0px;
					}

					&:last-child{
						padding-right: 0px;
					}

					&.input-group-50{
						width: 50%;
					}

					label{
						font-size: 16px;
						font-weight: var(--font-weight-regular);
						color: var(--color-grey);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						line-height: 19px;
						font-family: var(--font-family-fira);
					}

					input{
						font-size: 16px;
						line-height: 25px;
						padding-top: 8px;
						border-bottom: 1px solid var(--color-grey-light);
						display: block;
						width: 100%;
						font-weight: var(--font-weight-bold);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-dark);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						padding-top: 8px;
						padding-bottom: 10px;

						&:focus{
							border-color: var(--color-blue);
						}
					}

					.input-disabled{
						font-size: 16px;
						line-height: 25px;
						padding-top: 8px;
						border-bottom: 1px solid var(--color-grey-light);
						display: block;
						width: 100%;
						font-weight: var(--font-weight-bold);
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
						color: var(--color-grey);
						font-family: var(--font-family-poppins);
						text-transform: uppercase;
						padding-top: 8px;
						padding-bottom: 10px;
						cursor: default;
					}

					&.checkbox-acepto-comunicaciones{
						width: 100%;
						@include flex(row, flex-start, center);
						position: relative;

						input{
							opacity: 0;
							position: absolute;
							width: 25px;
							height: 25px;
							border: 0;

							&:checked + label{
								.checkbox-custom{
									&:before{
										opacity: 1;
									}
								}
							}
						}

						label{
							padding: 0;
							padding-top: 8px;
							padding-bottom: 10px;
							position: relative;
							@include flex(row, flex-start, center);

							.checkbox-custom{
								width: 25px;
								height: 25px;
								border: 1px solid var(--color-grey-light);
								margin-right: 16px;
								cursor: pointer;
								position: relative;
								background-color: var(--color-white);
								color: var(--color-red);

								&:before{
									content: url('../../assets/check-red.svg');
									position: absolute;
									z-index: 1;
									width: 25px;
									height: 25px;
									top: 50%;
									left: 50%;
									-webkit-transform: translate3d(-50%,-50%,0);
									-ms-transform: translate3d(-50%,-50%,0);
									transform: translate3d(-50%,-50%,0);
									opacity: 0;
									-webkit-transition: opacity 0.2s ease;
									transition: opacity 0.2s ease;
								}
							}

							span{
								font-size: 14px;
								font-weight: bold;
								font-family: var(--font-family-fira);
								color: var(--color-black);
								width: calc(100% - 41px);
							}
						}
					}
				}

				.btn{
					width: 100%;
					@include flex(row, center, center);
					text-transform: uppercase;
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					position: relative;
					cursor: pointer;
					width: 100%;
					background-color: var(--color-red);
					color: var(--color-white);
					-webkit-transition: background-color .2s ease;
					transition: background-color .2s ease;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					min-height: 48px;
					padding: 0 24px;
					font-size: 16px;
					line-height: 25px;
					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					outline-color: transparent;
					outline: none;
					box-shadow: none;
					border: 0;
					margin: 0;
					margin-top: 20px;

					&:hover{
						background-color: var(--color-blue-dark);
						text-decoration: none;
					}

					svg{
						width: 20px;
						height: auto;
						margin-left: 8px;
						stroke-width: 2.5px;
					}
				}

				.borrar-cuenta{
					width: 100%;
					@include flex(row, center, center);
					margin-top: 32px;
					color: var(--color-grey);
					font-family: var(--font-family-fira);
					font-size: 16px;
					-webkit-letter-spacing: 0;
					-moz-letter-spacing: 0;
					-ms-letter-spacing: 0;
					letter-spacing: 0;
					line-height: 19px;
					cursor: pointer;

					&:hover{
						color: var(--color-dark);
					}
				}

				.actualizar-info-text{
					width: 100%;
					text-align: center;
					@include flex(row, center, center);
					font-family: var(--font-family-fira);
					color: var(--color-grey);
					margin-top: 10px;
					font-size: 14px;
				}
			}
		}

		.mi-cuenta-right{
			top: 160px;
			position: sticky;
			width: calc(33.33% - 16px);
			@include flex(column, flex-start, flex-start);

			.mi-carne-socio{
				background-color: var(--color-blue-dark);
				padding: 32px 32px 20px 32px;
				width: 100%;
				@include flex(column, flex-start, flex-start);

				.card{
					margin: 0 0 24px;
					width: 100%;
					height: 56.25%;

					margin: 30px 0 45px;
					border-radius: 12px;
					width: calc(100% + 64px);
					height: auto;



					&.card--back{
						position: relative;
						box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.2);
						-webkit-transition: left .2s ease .3s;
						transition: left .2s ease .3s;
						left: -7px;
					}

					&.card--front{
						position: absolute;
						height: auto;
						top: 52px;
						box-shadow: 0 2px 40px 0 rgba(0, 0, 0, 0.4);
						-webkit-transition: left .2s ease .3s,-webkit-transform .2s ease .3s;
						-webkit-transition: left .2s ease .3s,transform .2s ease .3s;
						transition: left .2s ease .3s,transform .2s ease .3s;
						left: 0px;
						-webkit-transform: rotate(-10deg);
						-ms-transform: rotate(-10deg);
						transform: rotate(-10deg);
						width: 361px !important;
					}
				}
			}

			.mi-butaca{
				background-color: var(--color-blue);
				padding: 32px;
				width: 100%;
				@include flex(column, flex-start, flex-start);
				// margin-top: 16px;
			}

			.hacete-socio{
				width: 100%;
				margin: 0;
				@include flex(row, center, center);
				background-color: var(--color-red);
				padding: 12px 32px;

				a{
					text-decoration: none;
					color: var(--color-white);
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					text-transform: uppercase;
					font-size: 13px;
				}
			}

			.mi-cuenta-right-title{
				color: var(--color-blue-light);
				font-size: 13px;
				line-height: 20px;
				font-family: var(--font-family-poppins);
				font-weight: bold;
				text-transform: uppercase;
			}

			.cuenta-right-row{
				width: 100%;
				@include flex(row, space-between, center);
				border-bottom: 1px solid rgba(255,255,255,0.20);
				padding: 13px 0;

				&.row-last{
					border-bottom: none;
				}

				.cuenta-right-group{
					width: 100%;
					@include flex(column, center, flex-start);

					&.cuenta-right-group-50{
						width: 50%;
					}

					.mi-cuenta-right-label{
						color: var(--color-white);
						font-size: 13px;
						line-height: 20px;
						font-family: var(--font-family-poppins);
						font-weight: bold;
						text-transform: uppercase;
					}

					.mi-cuenta-right-valor{
						font-size: 32px;
						line-height: 38px;
						color: var(--color-white);
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
						margin: 0;
						-webkit-letter-spacing: 0;
						-moz-letter-spacing: 0;
						-ms-letter-spacing: 0;
						letter-spacing: 0;
					}
				}
			}
		}
	}


	.perfil-errors{
		@include flex(row, flex-start, center);
		padding: 0;
		margin: 15px 0;

		ul{
			list-style: none;
			margin: 0;
			padding: 0;

			li{
				width: 100%;
				font-size: 13px;
				font-weight: 700;
				color: #c61431;
				line-height: 1.5em;
			}
		}
	}

	.actualizadoOk{
		padding: 0;
		margin: 15px;
		font-size: 13px;
		font-weight: 700;
		color: #59ca73;
		line-height: 1.5em;
	}

	/* Responsive */
	@media screen and(max-width: 1244px){
		.mi-cuenta .mi-cuenta-right .mi-carne-socio{
			div{
				.card{
					&.card--back{
						display: none;
					}

					&.card--front{
						position: relative;
						top: 0px;
						left: 0px;
						width: 305px !important;
						margin: 30px 0;
						-webkit-transform: rotate(-8deg);
						transform: rotate(-8deg);
						left: -20px;
					}
				}
			}
		}
	}

	@media screen and(max-width: 1040px){
		.mi-cuenta .mi-cuenta-right .mi-carne-socio{
			div{
				.card{
					&.card--front{
						display: none;
					}
				}
			}
		}
	}

	@media screen and(max-width: 920px){
		.mi-cuenta {
			@include flex(column, flex-start, flex-start);

			.mi-cuenta-left{
				width: 100%;
			}

			.mi-cuenta-right{
				margin-top: 20px;
				position: relative;
				top: 0px;
				width: 100%;
			}
		}
	}

	@media screen and(max-width: 600px){
		.mi-cuenta {
			@include flex(column, flex-start, flex-start);

			.mi-cuenta-left{
				padding: 20px;

				.input-row{
					@include flex(column, center, flex-start);

					.input-group{
						width: 100%;
						padding: 0px;
						padding-bottom: 16px;

						&.input-group-50{
							width: 100%;
						}
					}
				}
			}

			// .mi-cuenta-right{
				
			// }
		}
	}


</style>